<script>
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { _ } from 'svelte-i18n';
    import { next, previous, goto, replace } from '../helpers/navigation.svelte.js';
    import { fetchApi } from '../helpers/api.svelte.js';

    import Section from '../components/Section.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';
    import Back from '../components/Back.svelte';
    import Loader from '../components/Loader.svelte';
    import Box from '../components/Box.svelte';
    import Header from '../components/Treatments/Header.svelte';
    import Treatment from '../components/Treatments/Treatment.svelte';
    import Information from '../components/Treatments/Information.svelte';
    import Text from '../components/Treatments/Text.svelte';
    import Title from '../components/Treatments/Title.svelte';
    import Separator from '../components/Treatments/Separator.svelte';
    import Pills from '../components/Treatments/Pills.svelte';

    import Icon from '../components/Icon.svelte';
    import arrowLeftIcon from '../assets/icons/arrow-left.svg?raw';

   
    const current = 'treatment';

    let rawTreatments = $state({});
    let previousTreatment = $state(null);
    let presetTreatment = $state(null);
    let id = $state(null);

    let treatments = $derived(
        app.settings.treatmentGroups
            .filter(group => group.id in rawTreatments)
            .map(group => ({
                ...group,
                treatments: rawTreatments[group.id] || []
            }))
    );
    

    function goBack() {
        currentSession.treatment = null;

        replace(previous(current), 'left');
    }

    function goNext(id) {
        currentSession.treatment = treatments.flatMap(group => group.treatments).find(item => item.id === id);
        persistent.treatment = id;

        goto(next(current), 'right');
    }

    function showAll() {
        presetTreatment = null;
    }

    async function getTreatments() {
        const form = new FormData();
        form.append('session', currentSessionId);
        form.append('client', currentSession.client);
        form.append('salon', currentSession.salon);

        let command = 'get';

        // Only filter by employee if stepsOrder is 'employee,treatment' AND origin is not Google Reserve
        // (Google Reserve forces treatment first regardless of stepsOrder)

        if (app.settings.stepsOrder === 'employee,treatment' && currentSession.origin !== 'google-reserve') {
            command = 'getForEmployee';
            form.append('employee', currentSession.employee?.id);
        }

        const data = await fetchApi({ 
            endpoint: `OnlineAppointment.Remote.Treatments/${command}`, 
            data: form 
        });

        rawTreatments = data.treatments;

        // Check for preset treatment from Google Reserve
        if (currentSession.preset?.treatment) {
            presetTreatment = treatments.flatMap(group => group.treatments).find(item => item.id == currentSession.preset.treatment);
        }

        // Check for previous treatment if no preset
        if (!presetTreatment && persistent.treatment) {
            previousTreatment = treatments.flatMap(group => group.treatments).find(item => item.id == persistent.treatment);
        }

        if (!id && treatments.length > 0) {
            id = treatments[0].id;
        }
	}

</script>

<svelte:head>
    <title>{$_('appointment_title')} - {presetTreatment ? $_('welcome') : $_('treatment')}</title>
</svelte:head>

    

<Section title={presetTreatment ? $_('welcome') : $_('treatment')}>
    {#snippet back()}
        {#if previous(current)}
            <Back onclick={goBack} />
        {/if}
    {/snippet}
    
    {#await getTreatments()}
        <Loader />
    {:then}
        {#if presetTreatment}
            <p>{$_('preset_choice')}</p>

            <div class='preset'>
                <Treatment treatment={presetTreatment} onclick={goNext} />
            </div>

            <Button onclick={showAll}>                
                <Icon data={arrowLeftIcon} />
                Toon alle behandelingen
            </Button>
        {:else}
            {#if previousTreatment}
                <p>{$_('previous_choice')}</p>

                <div class='previous'>
                    <Treatment treatment={previousTreatment} onclick={goNext} />
                </div>

                <p>{$_('or_choose_another_treatment')}</p>
            {:else}
                <p>{$_('choose_treatment')}</p>
            {/if}

            {#if treatments.length > 1}
                <Pills items={treatments} bind:id />
            {/if}

            {#each treatments as group}
                {#if id === group.id}
                    {#each group.treatments as item}
                        {#if item.type === 'treatment'}
                            <Treatment treatment={item} onclick={goNext} />
                        {/if}

                        {#if item.type === 'section'}
                            <Header {item} />
                        {/if}

                        {#if item.type === 'message'}
                            <Information {item} />
                        {/if}

                        {#if item.type === 'text'}
                            <Text {item} />
                        {/if}

                        {#if item.type === 'title'}
                            <Title {item} />
                        {/if}

                        {#if item.type === 'separator'}
                            <Separator />
                        {/if}
                    {/each}
                {/if}
            {/each}
        {/if}
    {/await}
</Section>


<style>

    .previous {
        margin-bottom: 5em;
    }

    .preset {
        margin-bottom: 1em;
    }

</style>